var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6L9 2.25L5.25 6",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.48657C14.9866 5.48657 14.9666 5.48657 14.9466 5.48657C11.4199 5.13324 7.89994 4.9999 4.41328 5.35324L3.05328 5.48657C2.77328 5.51324 2.52661 5.31324 2.49994 5.03324C2.47328 4.75324 2.67328 4.51324 2.94661 4.48657L4.30661 4.35324C7.85328 3.99324 11.4466 4.13324 15.0466 4.48657C15.3199 4.51324 15.5199 4.7599 15.4933 5.03324C15.4733 5.29324 15.2533 5.48657 14.9999 5.48657Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 4.81325C6.64009 4.81325 6.61342 4.81325 6.58009 4.80659C6.31342 4.75992 6.12675 4.49992 6.17342 4.23325L6.32009 3.35992C6.42675 2.71992 6.57342 1.83325 8.12675 1.83325H9.87342C11.4334 1.83325 11.5801 2.75325 11.6801 3.36659L11.8268 4.23325C11.8734 4.50659 11.6868 4.76659 11.4201 4.80659C11.1468 4.85325 10.8868 4.66659 10.8468 4.39992L10.7001 3.53325C10.6068 2.95325 10.5868 2.83992 9.88009 2.83992H8.13342C7.42675 2.83992 7.41342 2.93325 7.31342 3.52659L7.16009 4.39325C7.12009 4.63992 6.90675 4.81325 6.66675 4.81325Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1401 16.1667H6.8601C4.53343 16.1667 4.4401 14.8801 4.36676 13.8401L3.93343 7.12672C3.91343 6.85338 4.12676 6.61338 4.4001 6.59338C4.6801 6.58005 4.91343 6.78672 4.93343 7.06005L5.36676 13.7734C5.4401 14.7867 5.46676 15.1667 6.8601 15.1667H11.1401C12.5401 15.1667 12.5668 14.7867 12.6334 13.7734L13.0668 7.06005C13.0868 6.78672 13.3268 6.58005 13.6001 6.59338C13.8734 6.61338 14.0868 6.84672 14.0668 7.12672L13.6334 13.8401C13.5601 14.8801 13.4668 16.1667 11.1401 16.1667Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1067 12.5H7.88672C7.61339 12.5 7.38672 12.2733 7.38672 12C7.38672 11.7267 7.61339 11.5 7.88672 11.5H10.1067C10.3801 11.5 10.6067 11.7267 10.6067 12C10.6067 12.2733 10.3801 12.5 10.1067 12.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 9.83325H7.33325C7.05992 9.83325 6.83325 9.60658 6.83325 9.33325C6.83325 9.05992 7.05992 8.83325 7.33325 8.83325H10.6666C10.9399 8.83325 11.1666 9.05992 11.1666 9.33325C11.1666 9.60658 10.9399 9.83325 10.6666 9.83325Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_5467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d29ac0e0e820988fbd332789fe5e8d2d.svg";
export { ForwardRef as ReactComponent };